import React from 'react';

import { BrandMarkStyles as S } from './styles';

/** Same asset used by the dashboard navbar — no local Beam logo file in the repo. */
export const BEAM_LOGO_URL =
  'https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/attentive-logos/beamai.svg';

const BrandMark = ({ compact = false }) => (
  <S.Block>
    <S.Logo src={BEAM_LOGO_URL} alt='Beam' compact={compact} />
  </S.Block>
);

export default BrandMark;
